export { default } from './StudentEdit';

